export default __webpack_public_path__ + "static/media/pause-icon-blue.0c7988dc.svg";